import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import EnterpriseSignIn from '../components/enterprise-signin-view';
import { organizationHasVerifiedDomains } from 'modules/organization-module';
import {
  meData,
  meIsLoading,
  meIsOrganizationMember,
  meIsOrganizationAdmin,
} from 'modules/me-module';

export class EnterpriseSignInContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      personData: Object.assign({}, this.props.personData),
      errors: {},
      isDirty: false,
      modalIsOpen: false,
    };
  }

  openModal = () => {
    this.setState({modalIsOpen: true});
  };

  closeModal = () => {
    this.setState({modalIsOpen: false});
  };

  render() {
    return (
      <EnterpriseSignIn
        hasVerifiedOrgDomains={this.props.hasVerifiedOrgDomains}
        hideEnterpriseSignInDetails={this.props.isOrganizationMember && !this.props.isOrganizationAdmin}
        showEditLink={this.props.isOrganizationMember && this.props.isOrganizationAdmin}
      />
    );
  }
}

EnterpriseSignInContainer.propTypes = {
  personData: PropTypes.object.isRequired,
  hasVerifiedOrgDomains: PropTypes.bool.isRequired,
  isOrganizationMember: PropTypes.bool.isRequired,
  isOrganizationAdmin: PropTypes.bool.isRequired,
};

export const mapStateToProps = (state) => ({
  personData: meData(state),
  isLoading: meIsLoading(state),
  hasVerifiedOrgDomains: organizationHasVerifiedDomains(state),
  isOrganizationMember: meIsOrganizationMember(state),
  isOrganizationAdmin: meIsOrganizationAdmin(state),
});

export default connect(mapStateToProps)(EnterpriseSignInContainer);
